import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { _axios } from "../../plugins/axios";
import { URL } from "../../constants/constant";
import { Dialog, DialogTitle, DialogContent } from "@mui/material";

const WalletOTP = ({ visible, setVisibility, onSuccess, phone, type, packageDetails, paymentDetails }) => {
    const [sendOTP, setSendOTP] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState(phone);
    const [otp, setOtp] = useState(null);
    const [otpDataId, setOtpDataId] = useState(null);
    const [showMessage, setShowMessage] = useState(null);

  const sendOTPAPI = () => {
    const packageItems = packageDetails?.map((item) => item.packageName);
    const url = URL.dev_url;
    _axios
      .post(`${url}sendOTPForUsers`, { phonenumber: phoneNumber.toString(), type: type, packageItems, paymentDetails })
      .then(function (response) {
        setSendOTP(response.data.success);
        setOtpDataId(response.data.otpDataId);
        setShowMessage(null);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const verifyOtp = (event) => {
    const { name, value } = event.target;
    if (value.length == 4) {
        setOtp(value);
    } else {
      console.log("otp..", value);
    }
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    let url = URL.dev_url;
    let route = url + "verifyotp";
    console.log(otp);

    _axios
      .post(route, {
        phonenumber: phoneNumber,
        otp: otp,
        otpEvent: type,
        otpDataId: otpDataId
      })
      .then(function (response) {
        if (response.data.otpStatus) {
            onSuccess();
            setVisibility(false);
            setShowMessage(null);
        } else if (!response.data.otpStatus) {
            setShowMessage("Invalid OTP !");
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

return (
    <Dialog
        open={visible}
        onClose={() => setVisibility(false)}
        className="bottom-sheet-modal"
    >
        <DialogTitle>OTP Verification</DialogTitle>
        <DialogContent>
          <Row>
            <Col xs={12} md={12}>
              <Form onSubmit={(e) => handleSubmit(e)}>
                <Form.Group>
                  <Form.Label htmlFor="phoneNumber">Phone Number</Form.Label>
                  <Form.Control
                    type="number"
                    name="phoneNumber"
                    value={phoneNumber}
                    disabled={true}
                    placeholder="Enter Phone Number"
                    onChange={(e) => setPhoneNumber(e.target.value)}
                  />
                </Form.Group>

                <Form.Group>
                  <Form.Label htmlFor="otp">OTP</Form.Label>
                  <Form.Control type="password" name="otp" placeholder="Password" onChange={(e) => verifyOtp(e)} />
                </Form.Group>
                <div className="p-b-10">
                  {sendOTP ? (
                    <>
                      <Button variant="primary" type="submit" className="text-align-center w-100">
                        Verify OTP
                      </Button>
                      <div
                        className="text-align-center p-t-10 base-color font-size-smd bold"
                        onClick={(e) => sendOTPAPI(e)}
                      >
                        Resend OTP
                      </div>
                      <div className="text-align-center red-color font-size-smd bold p-t-10 ">{showMessage}</div>
                    </>
                  ) : (
                    <Button
                      variant="primary"
                      type="button"
                      onClick={(e) => sendOTPAPI(e)}
                      className="text-align-center w-100"
                    >
                      Send OTP
                    </Button>
                  )}
                </div>
              </Form>
            </Col>
          </Row>
        </DialogContent>
        </Dialog>
    ) 
}
export default WalletOTP;
